// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JY07r","col":"styles_col__37YZH"};